'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function getBrowserLanguage() {
    var nav = window.navigator;
    var languages = nav.languages || [];
    // support for HTML 5.1 "navigator.languages"
    for (var _i = 0, languages_1 = languages; _i < languages_1.length; _i++) {
        var language = languages_1[_i];
        if (language.length) {
            return language.split('_').join('-');
        }
    }
    // Support for other well known properties in browsers
    var browserLanguagePropertyKeys = [
        'language',
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore -- These are not technically according to spec, but... IE...
        'browserLanguage', 'systemLanguage', 'userLanguage',
    ];
    for (var _a = 0, browserLanguagePropertyKeys_1 = browserLanguagePropertyKeys; _a < browserLanguagePropertyKeys_1.length; _a++) {
        var browserLanguagePropertyKey = browserLanguagePropertyKeys_1[_a];
        var language = nav[browserLanguagePropertyKey];
        if (language && typeof language === 'string' && language.length) {
            return language.split('_').join('-');
        }
    }
    return null;
}

exports.default = getBrowserLanguage;
//# sourceMappingURL=browser_language.js.map
